import { all, takeLatest } from "redux-saga/effects";
import {
  EMAIL_TEMPLATE_LIST,
  EMAIL_TEMPLATE_CREATE,
  EMAIL_TEMPLATE_UPDATE,
  EMAIL_TEMPLATE_DELETE,
  EMAIL_TEMPLATE_DETAILE,
} from "../actions/emailtemplate.actions.types";
import httpClient from "../services/http.client";
import * as Effects from "redux-saga/effects";
import { successMessage } from "../../utilities/notification";

const call = Effects.call;

function* getEmailTemplateList({ payload: { data, callback } }) {
  const payload = {
    method: "get",
    url: "email-templates/list",
    params: data,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* createEmailTemplate({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "email-templates",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    successMessage(result.message);
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* updateEmailTemplate({ payload: { id, data, callback } }) {
  const payload = {
    data,
    method: "put",
    url: `email-templates/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    successMessage(result.message);
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* detailEmailTemplate({ payload: { id, callback } }) {
  const payload = {
    method: "get",
    url: `email-templates/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* deleteEmailTemplate({ payload: { id, callback } }) {
  const payload = {
    method: "delete",
    url: `email-templates/${id}?force=false`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    successMessage(result.message);
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* EmailTemplate() {
  yield all([
    takeLatest(EMAIL_TEMPLATE_LIST, getEmailTemplateList),
    takeLatest(EMAIL_TEMPLATE_CREATE, createEmailTemplate),
    takeLatest(EMAIL_TEMPLATE_UPDATE, updateEmailTemplate),
    takeLatest(EMAIL_TEMPLATE_DELETE, deleteEmailTemplate),
    takeLatest(EMAIL_TEMPLATE_DETAILE, detailEmailTemplate),
  ]);
}

export default EmailTemplate;
